export default {
  "name": "demo",
  "api": "https://api.demo.proapp.fi",
  "chat_api": "https://chat-demo.proapp.fi",
}
